const ReposActionTypes = {
  FETCHING_REPOS_START: 'FETCHING_REPOS_START',
  FETCHING_REPOS_SUCCESS: 'FETCHING_REPOS_SUCCESS',
  FETCHING_REPOS_FAILURE: 'FETCHING_REPOS_FAILURE',
  SET_REPOS_DEFAULT_STATE: 'SET_REPOS_DEFAULT_STATE',
};

export default ReposActionTypes;
